import Icon from '../components/Icon.vue'

Icon.register({
  history: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 255.5c0.3 136.6-111.2 248.4-247.8 248.5-59 0-113.2-20.5-155.8-54.9-11.1-8.9-11.9-25.5-1.8-35.6l11.3-11.3c8.6-8.6 22.4-9.6 31.9-2 31.4 24.9 71.1 39.8 114.3 39.8 101.7 0 184-82.3 184-184 0-101.7-82.3-184-184-184-48.8 0-93.1 19-126.1 49.9l50.8 50.8c10.1 10.1 2.9 27.3-11.3 27.3h-145.4c-8.8 0-16-7.2-16-16v-145.4c0-14.3 17.2-21.4 27.3-11.3l49.4 49.4c44.5-42.5 104.9-68.7 171.3-68.7 136.8 0 247.7 110.8 248 247.5zM323.1 334.3c-8.1 10.5-23.2 12.3-33.7 4.2l-65.4-50.9v-135.7c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v104.3l40.7 31.7c10.5 8.1 12.3 23.2 4.2 33.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/history.js
// module id = 1456
// module chunks = 0